import { useEffect, useState } from "react";
import { TableGeneral } from "../../../../components/table/TableGeneral";
import { columnsInfoPojectHrsSimulation } from "../hooks/columnSimulationInfo";


const TableProbjects = ({ isLoading, timeAreas = {}, calculatedTime, projection, simulationAsset, simulationProvider, equivalencyExtraResource }) => {
    const { columns: columnsHrs, props: propsHrs } = columnsInfoPojectHrsSimulation(undefined, undefined);
    const [areas, setAreas] = useState([]);


    useEffect(() => {
        const { assets: assetEquivalency, providers: providerEquivalency } = equivalencyExtraResource;
        const areasInformation = {
            planeación: {
                name: "Planeación",
                key: "Planeación",
                color: "#940bab",
                field: "planning",
                budget: 0,
                hrsWork: 0,
                projection: 0,
                hrsAssets: 0,
                hrsProvider: 0,
                hrsGlobalEstimated: calculatedTime.total,
            },
            "diseño ui/ux": {
                name: "Diseño UI/UX",
                key: "Diseño UI/UX",
                color: "#FF4081",
                field: "design",
                budget: 0,
                hrsWork: 0,
                projection: 0,
                hrsAssets: 0,
                hrsProvider: 0,
                hrsGlobalEstimated: calculatedTime.total,
            },
            "arte 3d": {
                name: "Arte 3D",
                key: "Arte 3D",
                color: "#7C4DFF",
                field: "modeling",
                budget: 0,
                hrsWork: 0,
                projection: 0,
                hrsAssets: 0,
                hrsProvider: 0,
                hrsGlobalEstimated: calculatedTime.total,
            },
            "programación unity": {
                name: "Programación Unity",
                key: "Programación Unity",
                color: "#02BCD4",
                field: "unity",
                budget: 0,
                hrsWork: 0,
                projection: 0,
                hrsAssets: 0,
                hrsProvider: 0,
                hrsGlobalEstimated: calculatedTime.total,
            },
            "programación web": {
                name: "Programación Web",
                key: "Programación Web",
                color: "#2ECD6F",
                field: "web",
                budget: 0,
                hrsWork: 0,
                projection: 0,
                hrsAssets: 0,
                hrsProvider: 0,
                hrsGlobalEstimated: calculatedTime.total,
            },

            testing: {
                name: "testing",
                key: "Testing",
                color: "#9cc",
                field: "testing",
                budget: 0,
                hrsWork: 0,
                projection: 0,
                hrsAssets: 0,
                hrsProvider: 0,
                hrsGlobalEstimated: calculatedTime.total,
            },
        };

        if (Object.values(timeAreas).length === 0) return;

        Object.values(timeAreas).forEach((area) => {
            const { name, field, timeTotalSpentArea, timeEstimated, substract } = area;
            const areaName = String(name.toLowerCase()).trim();

            areasInformation[areaName].key = `simulation-value-${name}`;
            areasInformation[areaName].name = name;
            areasInformation[areaName].budget = timeEstimated
            areasInformation[areaName].hrsWork = timeTotalSpentArea
            areasInformation[areaName].projection = projection[field]?.totalGeneral
            areasInformation[areaName].hrsAssets = simulationAsset[areaName].reduce((total, asset) => {
                const { price = 0, currency, status } = asset;
                if (status !== "Simulación") return total;

                const factor = currency === "MXN" ? assetEquivalency.hourMX.$numberDecimal : assetEquivalency.hourDLL.$numberDecimal;
                return total + price / factor;
            }, 0);
            areasInformation[areaName].hrsProvider = simulationProvider[areaName].reduce((total, provider) => {
                const { price = 0, outsourceHours = 0, currency, status, type } = provider;

                if (status !== "Simulación") return total;

                if (type === "B") return total + outsourceHours

                const factor = currency === "MXN" ? providerEquivalency.hourMX.$numberDecimal : providerEquivalency.hourDLL.$numberDecimal;
                return total + price / factor;
            }, 0);
            areasInformation[areaName].hrsRemaining = substract - areasInformation[areaName].hrsAssets - areasInformation[areaName].hrsProvider

        });
        setAreas(Object.values(areasInformation));
    }, [calculatedTime.total, equivalencyExtraResource, projection, simulationAsset, simulationProvider, timeAreas]);

    return (
        <div className="md:w-4/5">
            <TableGeneral loading={isLoading} state={areas} column={columnsHrs} tableProps={propsHrs} />
        </div>
    );
};

export default TableProbjects;
